// Vendor Libraries

try {

  window.$ = window.jQuery = require('jquery');

  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode ? 'is-ie' : 'is-not-ie';
  $('html').removeClass('no-js').addClass('is-loaded').addClass(isIE11);

} catch (e) {
  console.log(e);
}

jQuery(document).ready(function($) {

  // Components
  require('./components/utilities');
  require('./components/bootstrap');
  require('./components/colorbox');
  require('./components/js-cookies');
  require('./components/swiper');

  // Blocks


});